import { Checkbox, CheckboxGroup, Stack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { DISPLAYED_PERMISSIONS } from "services/customerPermissionsHelpers";

const PermissionsCheckboxSection = () => {
  const { register } = useFormContext<UserPermissionsFlags>();
  return (
    <CheckboxGroup>
      <Stack spacing={4}>
        <Checkbox isDisabled={true} {...register("readAccess")}>
          {DISPLAYED_PERMISSIONS.READ_ACCESS}
        </Checkbox>
        <Checkbox {...register("addEditOrders")}>
          {DISPLAYED_PERMISSIONS.ADD_EDIT_ORDERS}
        </Checkbox>
        <Checkbox {...register("signContracts")}>
          {DISPLAYED_PERMISSIONS.SIGN_CONTRACTS}
        </Checkbox>
        <Checkbox {...register("userManagement")}>
          {DISPLAYED_PERMISSIONS.USER_MANAGEMENT}
        </Checkbox>
        <Checkbox {...register("requestContract")}>
          {DISPLAYED_PERMISSIONS.REQUEST_CONTRACT}
        </Checkbox>
      </Stack>
    </CheckboxGroup>
  );
};

export default PermissionsCheckboxSection;
